import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const TYPE = "servicepaminnelse-sms";
const TEKSTVERSJON = "servicepaminnelse-v2";

// Reservasjon mot servicepåminnelser på SMS, på kundekortet. Kunden kan også
// reservere seg selv på Din side. Ny post per endring (samtykke-plan.md);
// verdi=false betyr reservert, ingen post betyr at kunden kan få påminnelser.
export default function Servicepaminnelse({ customerId }) {
  const [reservert, setReservert] = useState(null); // null = laster
  const [sist, setSist] = useState(null);
  const [opptatt, setOpptatt] = useState(false);
  const [feil, setFeil] = useState("");

  useEffect(() => {
    if (!customerId) return;
    fetch(`${API_BASE_URL}/samtykker/kunde/${customerId}`)
      .then((r) => (r.ok ? r.json() : Promise.reject()))
      .then((d) => {
        const post = (d.gjeldende || []).find((p) => p.type === TYPE) || null;
        setSist(post);
        setReservert(post?.verdi === false);
      })
      .catch(() => setFeil("Kunne ikke hente reservasjonen."));
  }, [customerId]);

  async function endre() {
    const nyVerdi = reservert; // reservert -> true (påminnelser igjen), ellers false
    setFeil("");
    setOpptatt(true);
    try {
      const r = await fetch(`${API_BASE_URL}/samtykker`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          customerId,
          type: TYPE,
          verdi: nyVerdi,
          tekstversjon: TEKSTVERSJON,
          ansatt: Cookies.get("selectedEmployee") || "",
        }),
      });
      if (!r.ok) throw new Error();
      const post = await r.json();
      setSist(post);
      setReservert(post.verdi === false);
    } catch {
      setFeil("Kunne ikke lagre. Prøv igjen.");
    } finally {
      setOpptatt(false);
    }
  }

  const naar = sist?.createdAt ? new Date(sist.createdAt).toLocaleDateString("nb-NO") : "";
  const hvem = sist?.kilde === "kundeportal" ? "kunden på Din side" : sist?.registrertAv || "";

  return (
    <div className="flex flex-wrap items-center gap-x-3 gap-y-1 text-sm text-gray-700 mb-4">
      <span className="text-gray-600 text-xs uppercase tracking-wide">Servicepåminnelse SMS</span>
      {reservert === null && !feil ? (
        <span className="text-gray-600">Laster…</span>
      ) : reservert === null ? null : (
        <>
          <span aria-live="polite" className={reservert ? "font-semibold text-red-700" : "text-gray-900"}>
            {reservert ? "Reservert" : "Ja"}
          </span>
          {sist && (
            <span className="text-xs text-gray-600">
              ({reservert ? "reservert" : "endret"} {naar}
              {hvem ? ` av ${hvem}` : ""})
            </span>
          )}
          <button
            type="button"
            onClick={endre}
            disabled={opptatt}
            className="text-sm px-3 py-1 rounded-md border border-gray-300 bg-white hover:bg-gray-50 disabled:opacity-50"
          >
            {opptatt ? "Lagrer…" : reservert ? "Fjern reservasjonen" : "Reserver kunden"}
          </button>
        </>
      )}
      {feil && (
        <span className="text-red-700" role="alert">
          {feil}
        </span>
      )}
    </div>
  );
}
